import * as config from './config';
import {init} from './init';



export const GTM = {
    config,
    init
};
